export const invertColor = (hex: string) => {
  if (hex.startsWith('#')) {
    hex = hex.slice(1);
  }

  // Convert 3-digit hex to 6-digits.
  if (hex.length === 3) {
    hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
  }

  if (hex.length !== 6) {
    return '#ffffff';
  }

  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);

  /**
   * The values 0.299, 0.587, and 0.114 represent the relative luminance
   * contribution of the red (R), green (G), and blue (B) channels, respectively
   * from the NTSC (National Television System Committee)
   */
  const luminance = red * 0.299 + green * 0.587 + blue * 0.114;
  return luminance > 186 ? '#000000' : '#ffffff';
};
export const generateColorShades = (inputColor: string, percentage: number) => {
  const baseColor = inputColor.toLowerCase();

  // Parse the hexadecimal color code
  const red = parseInt(baseColor.slice(1, 3), 16);
  const green = parseInt(baseColor.slice(3, 5), 16);
  const blue = parseInt(baseColor.slice(5, 7), 16);

  const percentageColor = percentage / 1000;
  const shadeRed = Math.round(red + (255 - red) * percentageColor);
  const shadeGreen = Math.round(green + (255 - green) * percentageColor);
  const shadeBlue = Math.round(blue + (255 - blue) * percentageColor);

  const color = (shadeRed << 16) | (shadeGreen << 8) | shadeBlue;
  const shadeHex = `#${color.toString(16).padStart(6, '0')}`;

  return shadeHex;
};

export function darkenHex(hex: string, percent: number) {
  if (!hex) {
    return '#000000';
  }

  hex = hex.replace(/^#/, '');

  let r = parseInt(hex.substring(0, 2), 16);
  let g = parseInt(hex.substring(2, 4), 16);
  let b = parseInt(hex.substring(4, 6), 16);

  r = Math.max(0, Math.min(255, r - (r * percent) / 100));
  g = Math.max(0, Math.min(255, g - (g * percent) / 100));
  b = Math.max(0, Math.min(255, b - (b * percent) / 100));

  const toHex = (value: number) =>
    Math.round(value).toString(16).padStart(2, '0');

  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}
